import Vivus from 'vivus';

export const titleAnime = {
  options: {
    root: null,
    rootMargin: '0px 0px',
    threshold: 0.5
  },
  svgs: [],
  id: [],
  vivus: [],
  duration: 0,
  init: ()=>{

    if(document.querySelectorAll('.js_svg_title')){

      //アニメーションするSVGs
      titleAnime.svgs = document.querySelectorAll('.js_svg_title');

      Array.prototype.slice.call(titleAnime.svgs,0).forEach((elm, i) => {
        titleAnime.id.push(elm.id);
        titleAnime.duration = elm.dataset.duration;

        //Vivus初期設定
        titleAnime.id[i] = new Vivus(elm.id, {
          duration: titleAnime.duration,
          start: "manual",
          type: "oneByOne"
        })

      });

      //初期化
      const observer = new IntersectionObserver(callback, titleAnime.options);
      //コールバック
      function callback(entries, observer){
        entries.forEach((entry) => {
          if(entry.isIntersecting){

            //可視範囲のIDとvivus IDが同じだったらplay
            Array.prototype.slice.call(titleAnime.id,0).forEach((elm, i) => {
              if(elm.el.id == entry.target.id){
                setTimeout(()=>{
                  elm.play();
                }, 400);
              }      
            });
            observer.unobserve(entry.target);
          }
        });
      }

      titleAnime.svgs.forEach((target) => {
        observer.observe(target);
      });


    }

  }
}
